/* eslint-disable @typescript-eslint/no-explicit-any */
import JanusError from './misc/error'
import JanusMessage from './misc/message'
import JanusPluginMessage from './misc/plugin-message'
import Session from './session'
import Transaction from './tx/transaction'
import TransactionManager from './tx/transaction-manager'

class Plugin extends TransactionManager {
  private static types = {}
  private session: Session | null
  private name: string
  private id: string

  initialize(session: Session, name: string, id: string) {
    this.session = session
    this.name = name
    this.id = id

    session.on('destroy', () => this.onDetached())
  }

  getSession(): Session | null {
    return this.session
  }

  getId(): string {
    return this.id
  }

  getName(): string {
    return this.name
  }

  getResponseAlias(): string {
    throw new Error('Plugin.getResponseAlias must be implemented.')
  }

  send(msg: any): Promise<any> {
    msg['handle_id'] = this.id
    if (this.session) {
      return this.session.send(msg)
    } else {
      return Promise.reject(new Error('No active session.'))
    }
  }

  detach(): Promise<void> {
    if (this.session) {
      return new Promise((resolve, reject) => {
        this.once('detach', resolve)
        this.sendWithTransaction({ janus: 'detach' }).catch(reject)
      })
    }
    return Promise.resolve()
  }

  onDetached(): Promise<any> {
    if (this.session) {
      this.session = null
      this.emit('detach')
    }
    return Promise.resolve()
  }

  cleanup(): Promise<any> {
    return this.onDetached()
  }

  processOutcomeMessage(msg: any): Promise<any> {
    return Promise.resolve(msg)
  }

  async processIncomeMessage(msg: JanusMessage): Promise<any> {
    try {
      msg = new JanusPluginMessage(msg.getPlainMessage(), this)
      if (msg.get('janus') === 'detached') {
        return this.onDetached()
      }
      await this.defaultProcessIncomeMessage(msg)
      return this.emit('message', msg)
    } catch (error) {
      this.emit('error', error)
    }
  }

  sendWithTransaction(options: any): Promise<any> {
    const transactionId = Transaction.generateRandomId()
    const transaction = new Transaction(transactionId, (msg) => {
      const errorMessage = msg.getError()
      if (!errorMessage) {
        return Promise.resolve(msg)
      }
      const error = new JanusError(msg)
      return Promise.reject(error)
    })

    const message = Object.assign({ janus: 'message', transaction: transactionId }, options)
    this.addTransaction(transaction)
    const sendPromise = this.sendSync(message, this)

    return new Promise((resolve, reject) => {
      transaction.getPromise().catch((e) => reject(e))
      sendPromise.then(
        (result) => resolve(result),
        (error) => reject(error),
      )
    })
  }

  toString() {
    return `[Plugin] ${JSON.stringify({ id: this.id, name: this.name })}`
  }
}

export default Plugin
